import Routine, { RUN } from "@bloglovin/inspire-engine/Routine";

/**
 * Server-only routine. All real work happens in
 * TalkToClaudeCodeRemoteControlSession.php — the browser never holds
 * the API/bridge secret and never issues the outbound HTTP request.
 * The client side is a pure no-op stub.
 *
 * This routine fires in two distinct shapes, so the client MUST NOT
 * validate a fixed param schema:
 *   - chat → bridge (TalkToClaude): params { project, messageContent,
 *     participant }.
 *   - auto-mode push (SetProjectAutoMode → PushAutoModeToBridge):
 *     params { address, payload, secret, timeout } — NO `project` key.
 * A client `assertValidParams` requiring `project` therefore threw
 * "expected object to have key project" on the auto-mode path, which
 * aborted the whole SetProjectAutoMode event BEFORE its claudeAutoMode
 * write ran — so the toggle silently never persisted. Since [RUN] does
 * nothing client-side, there is nothing to validate: keep it a no-op.
 * (Same class of bug as the PowerOnVm / PowerOffVm client stubs.)
 */
export default class TalkToClaudeCodeRemoteControlSession extends Routine {
  assertValidParams() {}

  [RUN](_params, _contexts) {
    return null;
  }
}

Routine.register("TalkToClaudeCodeRemoteControlSession", TalkToClaudeCodeRemoteControlSession);
